import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Media from 'local_modules/Media'
import actions from 'redux/actions'
import reduxForm from 'local_modules/redux-form'
import { modals, compose } from 'helpers'
import { required } from 'helpers/validation'

import Row from 'components/layout/Row/Row'
import Box from 'components/layout/Box/Box'
import Text from 'components/typography/Text/Text'
import Input from 'components/ui/form/Input/Input'
import Select from 'components/ui/form/Select/Select'
import TextArea from 'components/ui/form/TextArea/TextArea'
import FileInput from 'components/ui/form/FileInput/FileInput'
import Button from 'components/ui/Button/Button'
import HeroModal from 'components/HeroModal/HeroModal'
import ImageContainer from 'layers/heroes/components/ImageContainer/ImageContainer'

import s from './HeroAddModal.scss'


const genderOptions = [
  {
    title: 'Мужской',
    value: 'male',
  },
  {
    title: 'Женский',
    value: 'female',
  },
]


class HeroAddModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.HeroAdd,
  }

  componentDidMount() {
    window.dispatchEvent(new Event('resize'))
  }

  close = () => {
    const { name, data: { onClose } } = this.props

    actions.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  handleDelete = () => {
    const { data: { id, onDelete } } = this.props

    this.close()

    if (typeof onDelete === 'function') {
      onDelete(id)
    }
  }

  handleSubmit = (values) => {
    const { data: { onSubmit } } = this.props

    this.close()

    if (typeof onSubmit === 'function') {
      onSubmit(values)
    }
  }

  render() {
    const {
      fields, submitForm,
      data: { id, isModerator, fileInputProps: { setOnDone, clickInput } },
    } = this.props

    const isEdit = Boolean(id)

    return (
      <Media mobile>
        {
          (isMobile) => (
            <HeroModal
              onClose={this.close}
            >
              <Box mb={isMobile ? 24 : 40} mt={isMobile ? 24 : null}>
                <Text
                  message="Добавьте информацию о Герое"
                  size="30-36"
                  color="darkRed"
                  semibold
                />
              </Box>
              {
                isMobile ? (
                  <div>
                    <Box relative>
                      <ImageContainer
                        className={s.image}
                        gender={fields.gender.value}
                        src={fields.image.value}
                        min
                        noLazy
                        // w={270}
                      />
                      <Button
                        className={s.fileButton}
                        color="red"
                        size="md"
                      >
                        <Box pv={16}>
                          <Text
                            message={fields.image.value ? 'Заменить фото' : 'Добавить фото'}
                            color="white"
                            size="22-26"
                            semibold
                          />
                        </Box>
                        <FileInput
                          inputWrapperClassName={s.fileInput}
                          className={s.fileInputContainer}
                          textInputClassName={s.textInput}
                          valueLink={fields.image}
                          setOnDone={setOnDone}
                          onClick={clickInput}
                        />
                      </Button>
                    </Box>
                    <Box className={s.content} pt={24}>
                      <Input valueLink={fields.lastName} placeholder="Фамилия" withRequiredStar />
                      <Box mt={16}>
                        <Input valueLink={fields.firstName} placeholder="Имя" withRequiredStar />
                      </Box>
                      <Box mt={16}>
                        <Input valueLink={fields.middleName} placeholder="Отчество" />
                      </Box>
                      <Box mt={16}>
                        <Row>
                          <Text
                            message="Пол:"
                            size="16-19"
                            color="gray"
                          />
                          <Box ml={8} className={s.selectContainer}>
                            <Select valueLink={fields.gender} options={genderOptions} />
                          </Box>
                        </Row>
                      </Box>
                      <Box mt={16}>
                        <Input valueLink={fields.birth} placeholder="Год рождения" />
                      </Box>
                      <Box mt={16}>
                        <Input valueLink={fields.death} placeholder="Год смерти" />
                      </Box>
                      <Box mt={16}>
                        <Input valueLink={fields.sign} placeholder="Воинское звание" />
                      </Box>
                    </Box>
                  </div>
                ) : (
                  <Row align="start" justify="start">
                    <Box relative>
                      <ImageContainer
                        className={s.image}
                        gender={fields.gender.value}
                        src={fields.image.value}
                        min
                        noLazy
                        // w={270}
                      />
                      <Button
                        className={s.fileButton}
                        color="red"
                        size="md"
                      >
                        <Box pv={16}>
                          <Text
                            message={fields.image.value ? 'Заменить фото' : 'Добавить фото'}
                            color="white"
                            size="22-26"
                            semibold
                          />
                        </Box>
                        <FileInput
                          inputWrapperClassName={s.fileInput}
                          className={s.fileInputContainer}
                          textInputClassName={s.textInput}
                          valueLink={fields.image}
                          setOnDone={setOnDone}
                          onClick={clickInput}
                        />
                      </Button>
                    </Box>
                    <Box className={s.content} ml={36}>
                      <Input valueLink={fields.lastName} placeholder="Фамилия" withRequiredStar />
                      <Box mt={20}>
                        <Input valueLink={fields.firstName} placeholder="Имя" withRequiredStar />
                      </Box>
                      <Box mt={20}>
                        <Input valueLink={fields.middleName} placeholder="Отчество" />
                      </Box>
                      <Box mt={20}>
                        <Row>
                          <Text
                            message="Пол:"
                            size="16-19"
                            color="gray"
                          />
                          <Box ml={8} className={s.selectContainer}>
                            <Select valueLink={fields.gender} options={genderOptions} />
                          </Box>
                        </Row>
                      </Box>
                      <Box mt={20}>
                        <Input valueLink={fields.birth} placeholder="Год рождения" />
                      </Box>
                      <Box mt={20}>
                        <Input valueLink={fields.death} placeholder="Год смерти" />
                      </Box>
                      <Box mt={20}>
                        <Input valueLink={fields.sign} placeholder="Воинское звание" />
                      </Box>
                    </Box>
                  </Row>
                )
              }
              <Box pt={24}>
                <TextArea className={s.textArea} valueLink={fields.description} placeholder="История о Герое" />
              </Box>
              <Box pt={8}>
                <Text
                  message="* Поля помеченные красной звездочкой обязательны для заполнения"
                  size="14-17"
                  color="red"
                />
              </Box>
              <Box pt={24}>
                <Button
                  color="gold"
                  size="md"
                  fullWidth
                  onClick={submitForm(this.handleSubmit)}
                >
                  <Box pv={16}>
                    <Text
                      message={isModerator ? 'Одобрить' : 'Готово'}
                      color="white"
                      size="22-26"
                      semibold
                    />
                  </Box>
                </Button>
              </Box>
              {
                isEdit && (
                  <Box mt={16}>
                    <Button
                      color="redInverted"
                      size="md"
                      fullWidth
                      onClick={this.handleDelete}
                    >
                      <Box pv={16}>
                        <Text
                          message="Удалить"
                          color="inherit"
                          size="22-26"
                        />
                      </Box>
                    </Button>
                  </Box>
                )
              }
            </HeroModal>
          )
        }
      </Media>
    )
  }
}


export default compose(
  reduxForm((props) => ({
    name: 'learnForm',
    fields: {
      id: [],
      lastName: [ required ],
      firstName: [ required ],
      middleName: [],
      gender: [ required ],
      birth: [],
      death: [],
      sign: [],
      description: [],
      image: [],
    },
    initialValues: () => ({
      id: props.data.id || '-',
      lastName: props.data.lastName,
      firstName: props.data.firstName,
      middleName: props.data.middleName,
      gender: props.data.gender || 'male',
      birth: props.data.birth,
      death: props.data.death,
      sign: props.data.sign,
      description: props.data.description,
      image: props.data.image,
    })
  })),
)(HeroAddModal)
